import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import './RoomListAdsCarousel.css';

/** Figma 20627:2074 — room list ads: Shemaroo + RapBazaar only */
export const ROOM_LIST_AD_BANNERS = [
  {
    id: 'shemaroo',
    src: IMAGE_CONSTANTS.V2_ROOM_LIST_AD_SHEMAROO,
    alt: 'Shemaroo Me',
    url: 'https://www.shemaroome.com/',
    nodeId: '20627:2075',
  },
  {
    id: 'rapbazaar',
    src: IMAGE_CONSTANTS.V2_ROOM_LIST_AD_RAPBAZAAR,
    alt: 'RapBazaar',
    url: 'https://rapbazaar.rapchiklife.com/',
    nodeId: '20627:2076',
  },
];

/**
 * Figma 20627:2074 — 753×376 carousel, white 2px border, 16px radius,
 * diamond indicators (2 banners only).
 */
const RoomListAdsCarousel = ({
  banners = ROOM_LIST_AD_BANNERS,
  intervalMs = 5000,
  className = '',
}) => {
  const slides = Array.isArray(banners) ? banners.filter((b) => b?.src).slice(0, 2) : [];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (slides.length < 2) return undefined;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [slides.length, intervalMs]);

  useEffect(() => {
    if (index >= slides.length) setIndex(0);
  }, [index, slides.length]);

  if (!slides.length) return null;

  return (
    <aside
      className={`room-list-ads${className ? ` ${className}` : ''}`}
      data-node-id="20627:2074"
      aria-label="Advertisements"
    >
      <div className="room-list-ads__viewport">
        {slides.map((slide, slideIndex) => {
          const isActive = slideIndex === index;
          const image = (
            <img
              className="room-list-ads__image"
              src={slide.src}
              alt={slide.alt || 'Advertisement'}
              draggable={false}
            />
          );
          return (
            <div
              key={slide.id || slideIndex}
              className={`room-list-ads__slide${isActive ? ' is-active' : ''}`}
              data-node-id={slide.nodeId}
              aria-hidden={!isActive}
            >
              {slide.url ? (
                <a
                  href={slide.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={slide.alt || 'Advertisement'}
                >
                  {image}
                </a>
              ) : (
                image
              )}
            </div>
          );
        })}
      </div>

      {slides.length > 1 ? (
        <div
          className="room-list-ads__dots"
          data-node-id="20627:2077"
          aria-label="Advertisement slides"
        >
          {slides.map((slide, slideIndex) => (
            <button
              key={`dot-${slide.id || slideIndex}`}
              type="button"
              className={`room-list-ads__dot${slideIndex === index ? ' is-active' : ''}`}
              onClick={() => setIndex(slideIndex)}
              aria-label={`Show ad ${slideIndex + 1}`}
              aria-current={slideIndex === index ? 'true' : undefined}
            />
          ))}
        </div>
      ) : null}
    </aside>
  );
};

RoomListAdsCarousel.propTypes = {
  banners: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      url: PropTypes.string,
      nodeId: PropTypes.string,
    })
  ),
  intervalMs: PropTypes.number,
  className: PropTypes.string,
};

export default RoomListAdsCarousel;
